import GUI from 'lil-gui';

export default class DebugUI
{
    constructor()
    {
        console.log('Created DebugUI.')

        this.active = window.location.hash === '#debug';

        if(this.active)
        {
            this.ui = new GUI();
        }
    }
}